import React from 'react'
import { LockOutlined, UserOutlined } from '@ant-design/icons'
import { T, useT } from '@transifex/react'
import { Form, Input, Button, Checkbox } from 'src/antd'

import {
  FormFn,
  WithFormInitializer,
  useStore,
} from 'src/new-components/antdform-kit-v2'
import { VALIDATORS } from 'src/new-components/antdform-utils/validation'

import { FormSchema } from './types'

export * from './types'

type TLoginFormProps = {
  formId: string
  onSubmit: (values: FormSchema) => void
}

export const initialValues: FormSchema = {
  username: ``,
  password: ``,
  rememberMe: false,
}

const LoginForm = WithFormInitializer<TLoginFormProps>(
  ({ formId, onSubmit }) => {
    const t = useT()
    const isSubmitting = useStore((store) => store[formId].isSubmitting)

    const translationSubmit = t('Log in')
    const translationPassword = t('Password')
    const translationUsername = t('Username')

    return (
      <FormFn
        formId={formId}
        msgSuccessName=""
        disableDefaultSuccessMessage
        onFinish={onSubmit}
        style={{ width: 300 }}
        initialValues={initialValues}
      >
        <Form.Item name="username" rules={[VALIDATORS.required]}>
          <Input
            type="text"
            placeholder={translationUsername}
            prefix={<UserOutlined className="site-form-item-icon" />}
          />
        </Form.Item>
        <Form.Item name="password" rules={[VALIDATORS.required]}>
          <Input
            type="password"
            placeholder={translationPassword}
            prefix={<LockOutlined className="site-form-item-icon" />}
          />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            size="middle"
            htmlType="submit"
            loading={isSubmitting}
            style={{ width: '100%' }}
          >
            {translationSubmit}
          </Button>
        </Form.Item>
        <Form.Item>
          <Form.Item name="rememberMe" valuePropName="checked" noStyle>
            <Checkbox indeterminate={false}>
              <T _str="Remember me" />
            </Checkbox>
          </Form.Item>

          <a href="/forgot-password" style={{ float: 'right' }}>
            <T _str="Forgot password" />
          </a>
        </Form.Item>
      </FormFn>
    )
  }
)

export default LoginForm
